import { useMemo } from 'react';
import { useTargetingContext } from '../context/TargetingContext.tsx';

type UseTargetingDisabledStateResult = {
  isDisabled: boolean;
  disabledReasonMessage?: string;
  hasError: boolean;
  errorReasonMessage?: string;
  isDisabledOrHasError: boolean;
};

export const defaultTargetingBlockingRules = {
  blockedTargetingFields: {},
  getDisabledReason: () => undefined,
  isFieldDisabled: () => false,
  getErrorReason: () => undefined,
  hasFieldError: () => false,
};

export const useTargetingDisabledState = (fieldPath?: string): UseTargetingDisabledStateResult => {
  const targetingContext = useTargetingContext();

  const targetingBlockingRules = targetingContext?.targetingBlockingRules ?? defaultTargetingBlockingRules;

  const disabledReasonMessage = fieldPath ? targetingBlockingRules.getDisabledReason(fieldPath) : undefined;
  const isDisabled = fieldPath ? targetingBlockingRules.isFieldDisabled(fieldPath) : false;

  const errorReasonMessage = fieldPath ? targetingBlockingRules.getErrorReason?.(fieldPath) : undefined;
  const hasError = fieldPath
    ? (targetingBlockingRules.hasFieldError?.(fieldPath) ?? Boolean(errorReasonMessage))
    : false;
  const isDisabledOrHasError = isDisabled || hasError;

  return useMemo(
    () => ({
      isDisabled,
      disabledReasonMessage,
      hasError,
      errorReasonMessage,
      isDisabledOrHasError,
    }),
    [disabledReasonMessage, errorReasonMessage, hasError, isDisabled, isDisabledOrHasError]
  );
};
